<template lang="pug">
  div.alert.alert-info(role='alert' v-if="message") {{ message }}
</template>

<script>
export default {
  props: ['message'],
};
</script>
